import { http } from '@/utils/http';
import qs from 'qs';
// const baseUrl = '/vote/2020project/2020hometownstory/controller.php?enews=';
const baseUrl = '/vote/2020project/2020doctor/controller.php?enews=';

export const getBaseInfo = () => {
  return http.get(`${baseUrl}base-info`);
};

// 规则
export const getRules = () => {
  return http.get(`${baseUrl}rules`);
};

// 新闻列表
export function getNewslist(voteName: string, page: number) {
  return http.get(`${baseUrl}news`, {
    params: { page },
  });
}

// 新闻列表
export function getOutpatientlist(voteName: string, page: number) {
  return http.get(`${baseUrl}outpatient`, {
    params: { page },
  });
}

// 新闻列表
export function getDeanslist(voteName: string, page: number) {
  return http.get(`${baseUrl}dean`, {
    params: { page },
  });
}

